import _extends from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonContent from '~/components/CommonContent';
import { mapState } from 'vuex';
export default {
  components: {
    CommonContent: CommonContent
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          query = _ref.query;
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return store.dispatch("getPageData", { id: "11", lang: query.lang });

            case 2:
              result = _context.sent;
              return _context.abrupt('return', { pageData: result });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {
      items: [{ name: '管理团队', introduce: '管理团队', headimgurl: require('../../static/images/team/team2.jpg') }, { name: '设计团队', introduce: '我们与来自日本，韩国，英国，美国等，国际一流造景师合作，以专业的视角，认真的态度打造顶级的园林。', headimgurl: require('../../static/images/team/team4.jpg') }, { name: '施工团队', introduce: '一支来自草原的队伍，在最紧的工期，最大的工作量下，他们从不畏惧，保质保量的完成每一个工程是东丽施工队始终如一的信念。', headimgurl: require('../../static/images/team/team5.jpg') }, { name: '技术团队', introduce: '每一个复杂且困难的工程保质保量完成的背后，都有着我们最专业的技术人员们保驾护航，他们涉及绿化施工，土建施工，电气施工，测量验线，给水施工，材料机械，园艺修剪，苗木养护等各个方面 。', headimgurl: require('../../static/images/team/team5.jpg') }, { name: '精养团队', introduce: '以认真负责的态度对待每一个养护区域，熟悉了解区域内每一种植被的生长习性，病虫害防治。东丽养护团队里的每一个成员，均将竭尽全力守护好每一处园林景观的花草树木。', headimgurl: require('../../static/images/team/team4.jpg') }, { name: '基地维护团队', introduce: '基地维护团队介绍代替文字介绍代替文字介绍代替文字介绍代替文字介绍代替文字介绍代替文字介绍代替文字介绍代替文字', headimgurl: require('../../static/images/team/team2.jpg') }]
    };
  },

  computed: _extends({}, mapState(['winHeight']), {
    up: function up() {
      return {
        height: this.winHeight - 60 + 'px'
      };
    },
    descPageData: function descPageData() {
      var _this = this;

      return this.pageData.map(function (val, key) {
        return _this.pageData[_this.pageData.length - 1 - key];
      });
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/us/team.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/us/team.vue
// module chunks = 3